import { createElement, Dispatch, SetStateAction, useCallback, useMemo } from "react";
import { DateRange } from "react-day-picker";
import { dashboardFiltersBadgeComponents } from "../../constants/dashboards/dashboardFilters.constant";
import { DashboardFilters } from "../../types/dashboards/dashboard.type";
import { DashboardComponentFiltersParams } from "../../types/dashboards/dashboardComponent.type";

interface DashboardBadgeFiltersProps {
  filters: DashboardComponentFiltersParams & {
    date: DateRange | undefined;
  };
  setFilters: Dispatch<SetStateAction<DashboardComponentFiltersParams & {
    date: DateRange | undefined;
  }>>;
  dashboardDesiredFilters: DashboardFilters[];
  width: number;
}

const DashboardBadgeFilters = ({
  filters,
  setFilters,
  dashboardDesiredFilters,
  width,
}: DashboardBadgeFiltersProps) => {
  const renderFilters = useCallback((desiredFilter: DashboardFilters) => {
    const Component = dashboardFiltersBadgeComponents[desiredFilter];

    if (!Component)
      return null;

    return createElement(Component, {
      key: desiredFilter,
      filters: filters,
      setFilters: setFilters,
    });
  }, [filters, setFilters]);

  const calcFiltersToDisplay = useMemo(() => {
    return Math.max(1, Math.floor((width - 600) / 230));
  }, [width]);

  return dashboardDesiredFilters?.slice(0, calcFiltersToDisplay)?.map(renderFilters);
}

export default DashboardBadgeFilters;
